module.exports = __webpack_public_path__ + "71c26920de6030dff616b6ee28b3fdf4.svg";